import { FormControl, FormGroup, Validators } from '@angular/forms';
import { confirmPasswordValidator } from '../../shared/validators/password-validator';

export class RegisterModel {
  public username?: string;
  public title?: string;
  public firstName?: string;
  public lastName?: string;
  public emailAddress?: string;
  public mobile?: string;
  public phone?: any;
  public countryCode?: string;
  public region?: string;
  public accreditationNumber?: string;
  public password?: string;
  public passwordConfirm?: string;
  public acceptTerms?: string;
  public isVet?: boolean;

  static asFormGroup(model: RegisterModel): FormGroup {
    const fg = new FormGroup({
      username: new FormControl(model?.username),
      title: new FormControl(model?.title || ''),
      firstName: new FormControl(model?.firstName, Validators.required),
      lastName: new FormControl(model?.lastName, Validators.required),
      emailAddress: new FormControl(model?.emailAddress, [Validators.required, Validators.email]),
      businessName: new FormControl('', Validators.required),
      accreditationNumber: new FormControl('', Validators.required),
      region: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      passwordConfirm: new FormControl('', [Validators.required, confirmPasswordValidator]),
      acceptTerms: new FormControl(false, Validators.requiredTrue),
      acceptPrivacy: new FormControl(false, Validators.requiredTrue),
      phone: new FormControl(model?.mobile, Validators.required)
    });
    return fg;
  }
}

